var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 6.0444V25.9555C3.2 27.5199 4.46577 28.7999 6.04444 28.7999H25.9556C27.52 28.7999 28.8 27.5199 28.8 25.9555V6.0444C28.8 4.47995 27.52 3.19995 25.9556 3.19995H6.04444C4.46577 3.19995 3.2 4.47995 3.2 6.0444ZM20.2667 11.7333C20.2667 14.0942 18.3609 16 16 16C13.6391 16 11.7333 14.0942 11.7333 11.7333C11.7333 9.3724 13.6391 7.46662 16 7.46662C18.3609 7.46662 20.2667 9.3724 20.2667 11.7333ZM7.46666 23.1111C7.46666 20.2666 13.1556 18.7022 16 18.7022C18.8444 18.7022 24.5333 20.2666 24.5333 23.1111V24.5333H7.46666V23.1111Z",
    fill: "#666666"
  })));
};
export default SvgAccount;